import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from './Link';
import {InfoIcon} from './svg';

const InlineNotificationContent = ({children, ctaText}) => (
  <div className="flex">
    <div className="flex-shrink-0">
      <InfoIcon className="h-5 w-5 text-blue-600" />
    </div>
    <div className="ml-3 flex-1 md:flex md:justify-between md:items-center">
      <p className="text-sm text-blue-600 font-medium text-left">
        {children}
      </p>
      {ctaText && (
      <p className="whitespace-nowrap font-semibold underline text-center text-blue-600 hover:text-blue-700 mt-3 text-sm md:mt-0 md:ml-6">
        {ctaText}
      </p>
      )}
    </div>
  </div>
);

const InlineNotification = ({
  href,
  onClick,
  className = '',
  ...props
}) => {
  if (!href && !onClick) {
    return (
      <span className={cx('w-full block rounded-md bg-blue-100 p-4', className)}>
        <InlineNotificationContent {...props} />
      </span>
    );
  }

  if (href) {
    return (
      <Link href={href} className={cx('w-full block rounded-md bg-blue-100 p-4', className)}>
        <InlineNotificationContent {...props} />
      </Link>
    );
  }

  if (onClick) {
    return (
      <button
        className={cx('w-full rounded-md bg-blue-100 p-4', className)}
        onClick={onClick}
        type="button"
      >
        <InlineNotificationContent {...props} />
      </button>
    );
  }

  return null;
};

InlineNotification.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  ctaText: PropTypes.string,
};

export default InlineNotification;
